// hooks/useYupSchema.js
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import yup, { configureYup } from '../util/yupConfig';

export const useYupSchema = (schemaDefinition) => {
  const { language } = useSelector(state => state.configuration);

  const schema = useMemo(() => {
    // Configurar Yup con el idioma actual
    configureYup(language);
    
    // Retornar el schema definido
    return schemaDefinition(yup);
  }, [language, schemaDefinition]);

  return schema;
};